import { component } from 'picoapp'
import { toggle } from './toggle'

export default component((node, ctx) => {
  // console.log('search init') 
  const openSearch = node.querySelectorAll('.js-open-search') // open search selector
  const searchForm = node.querySelectorAll('.js-header-search input') // search inputs

  // opens search dialog
  for (let i = 0; i < openSearch.length; i++) {
    const search = openSearch[i];
    // console.log(search)

    search.addEventListener('click', function(evt) {
      const closestInput = search.nextElementSibling; // find the search input (div)
      const inpt = closestInput.querySelector('input'); // grab the input
      evt.preventDefault() // stop reload
      toggle(closestInput) // toggle the search input
      inpt.focus() // focus the input
    }) 
  }

  for (let i = 0; i < searchForm.length; i++) {
    // console.log(searchForm[i])
    const searchInp = searchForm[i]
    
    searchInp.addEventListener('focusout', function() {
      const pa = searchInp.parentElement
      searchInp.value = ''
      toggle(pa)
    }) 
  }

  return node => {
    console.log('search unmounted')
  }
}) 